import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import { handleFetchErrors, entityReplacer } from './utils'
import { RawRunEvent } from '../utils/type'
import React from 'react'

export function fetchEntityStartAndNumberTimestamp(parentId: number): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/run/getLastEndAndNumberRunFromSection`, {
        method: 'POST',
        body: JSON.stringify({ parentId }),
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            return res.body
        })
        .catch(err => {
            globalNotification.error(i18n(`Error getting Start and Run Number from Run.`))

            return Promise.reject()
        })
}

export function updateRunExtendLastTubular(run: RawRunEvent): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/run/updateExtendLastTubular`, {
        method: 'POST',
        body: JSON.stringify(run, entityReplacer),
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            globalNotification.success(`${i18n(`Tubulars configuration updated successfully`)}`)

            return res.body
        })
        .catch((err: Response) => {
            err.json()
                .then(json =>
                    globalNotification.error(i18n(`Unable to update tubulars configuration: `)`${json.message || ''}`)
                )
                .catch(globalNotification.error(i18n(`Unable to update tubulars configuration: `)`${err.status || ''}`))

            return Promise.reject()
        })
}

export function deleteAllTubularsFromRun(id: number): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/run/deleteAllTubularsFromRun/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => {
            if (r.status === 200) {
                globalNotification.success(i18n(`The run tubulars were successfully deleted`))
            }
        })
        .catch(err =>
            err?.json
                ? err
                      .json()
                      .then(body =>
                          globalNotification.error(
                              `${i18n('Unable to delete run tubulars')}${body?.message && `: ${body?.message}`}`
                          )
                      )
                : globalNotification.error(i18n(`Unable to delete run tubulars`))
        )
}
